"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('six-points', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M28 40C28 42.2091 26.2091 44 24 44C21.7909 44 20 42.2091 20 40C20 37.7909 21.7909 36 24 36C26.2091 36 28 37.7909 28 40Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M28 8C28 10.2091 26.2091 12 24 12C21.7909 12 20 10.2091 20 8C20 5.79086 21.7909 4 24 4C26.2091 4 28 5.79086 28 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M42 16C42 18.2091 40.2091 20 38 20C35.7909 20 34 18.2091 34 16C34 13.7909 35.7909 12 38 12C40.2091 12 42 13.7909 42 16Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M42 32C42 34.2091 40.2091 36 38 36C35.7909 36 34 34.2091 34 32C34 31.2969 34.1814 30.6362 34.4999 30.0621C35.1823 28.8323 36.4939 28 38 28C40.2091 28 42 29.7909 42 32Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M14 16C14 18.2091 12.2091 20 10 20C7.79086 20 6 18.2091 6 16C6 13.7909 7.79086 12 10 12C12.2091 12 14 13.7909 14 16Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M14 32C14 34.2091 12.2091 36 10 36C7.79086 36 6 34.2091 6 32C6 29.7909 7.79086 28 10 28C11.5061 28 12.8177 28.8323 13.5001 30.0621C13.8186 30.6362 14 31.2969 14 32Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M24 24L13.5001 30.0621M24 24L34.4999 30.0621M24 24V12M24 12C26.2091 12 28 10.2091 28 8C28 5.79086 26.2091 4 24 4C21.7909 4 20 5.79086 20 8C20 10.2091 21.7909 12 24 12ZM13.5001 30.0621C12.8177 28.8323 11.5061 28 10 28C7.79086 28 6 29.7909 6 32C6 34.2091 7.79086 36 10 36C12.2091 36 14 34.2091 14 32C14 31.2969 13.8186 30.6362 13.5001 30.0621ZM34.4999 30.0621C34.1814 30.6362 34 31.2969 34 32C34 34.2091 35.7909 36 38 36C40.2091 36 42 34.2091 42 32C42 29.7909 40.2091 28 38 28C36.4939 28 35.1823 28.8323 34.4999 30.0621ZM28 40C28 42.2091 26.2091 44 24 44C21.7909 44 20 42.2091 20 40C20 37.7909 21.7909 36 24 36C26.2091 36 28 37.7909 28 40ZM42 16C42 18.2091 40.2091 20 38 20C35.7909 20 34 18.2091 34 16C34 13.7909 35.7909 12 38 12C40.2091 12 42 13.7909 42 16ZM14 16C14 18.2091 12.2091 20 10 20C7.79086 20 6 18.2091 6 16C6 13.7909 7.79086 12 10 12C12.2091 12 14 13.7909 14 16Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;